export namespace RideRequestTypeConstants {
  export const SCHEDULED = 'SCHEDULED';
  export const WILL_CALL = 'WILLCALL';
  export const RECOVERY = 'RECOVERY';
  export const RIDE_NOW = 'RIDENOW';
}
